<div class="u-shadow-mini {{ sectionclass }}" style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap"
		>
			<div class="o-stack__cell">
				<h5>{{ sectiontitle }}</h5>
				<span>
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSV($event)"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
					>
						<i class="fa fa-download" aria-hidden="true"></i>
					</a>
				</span>
			</div>
		</div>
		<div class="r2-conversion-metrics-header" *ngIf="hasData">
			<div class="sem-conversion-metrics" *ngFor="let metric of metricObject">
				<div class="conversion-metrics">
					<div class="metric-value" appTooltip [attr.title]="metric?.tooltip" [options]="tooltipOptions">
						{{ metric.value }}
					</div>
					<div class="metric-name">
						{{ metric.name }}
					</div>
				</div>
			</div>
		</div>
		<div class="analytics-portlet-content" style="position: relative; height: 430px">
			<div class="o-stack o-stack--nowrap o-stack--center">
				<div class="donut-chart-container" *ngFor="let config of multichartconfigurations; let i = index">
					<!-- <div #chartElement></div> -->
					<app-generic-chart
						id="device-id-{{ i }}"
						[configuration]="config"
						[colorPalette]="colorPalette"
						[data]="devicesChartData"
					>
					</app-generic-chart>
					<div
						style="background: #fff; z-index: 10001; position: absolute; top: 0; left: 0; width: 100%; height: 100%"
						*ngIf="!hasData"
					>
						<div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)">
							No Data Available.
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="device-table-widget" *ngFor="let datatableConfig of multidatatableconfigurations">
			<ngx-datatable
				class="datatable"
				[rows]="deviceLegendData"
				[columns]="datatableConfig['columns']"
				[sortType]="'single'"
				[columnMode]="'force'"
				[headerHeight]="50"
				[footerHeight]="50"
				[rowHeight]="'auto'"
				[limit]="10"
				[reorderable]="reorderable"
				*ngIf="hasData"
			>
			</ngx-datatable>
		</div>
	</div>
</div>
